// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1KZNo","inner":"Footer_inner__Optz8","nextIcon":"Footer_nextIcon__3RMOX","innerLeft":"Footer_innerLeft__eWdk1"};